import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal__parking-board-template-wrapper" }
const _hoisted_2 = { class: "modal__parking-name" }
const _hoisted_3 = { class: "modal__parking-row" }
const _hoisted_4 = { class: "modal__parking-desc" }
const _hoisted_5 = {
  key: 0,
  class: "modal__parking-count"
}
const _hoisted_6 = {
  key: 0,
  class: "modal__parking-zone-count"
}
const _hoisted_7 = { class: "modal__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parkingBoards, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "modal__parking-item"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_translated_text_component, { translation: "parking_board_name" }),
            _createTextVNode(" " + _toDisplayString(item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.description), 1),
            (item.last_status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (item.last_status.available_car_parking_spots
            || item.last_status.available_car_parking_spots == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_translated_text_component, { translation: "modal_parking_free_spaces_amount" })
                        ]),
                        _createElementVNode("div", {
                          style: _normalizeStyle({'color': item.last_status.text_color}),
                          class: "modal__parking-zone-count-value"
                        }, _toDisplayString(item.last_status.available_car_parking_spots), 5)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}